// src/components/strumenti/AutonomiaBatteria.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function AutonomiaBatteria() {
  const [capacita, setCapacita] = useState("");
  const [assorbimento, setAssorbimento] = useState("");
  const [rendimento, setRendimento] = useState("80");

  const Ah = leggiNumero(capacita)||0;
  const mA = leggiNumero(assorbimento)||0;
  const rend = (leggiNumero(rendimento)||100)/100;
  const A = mA/1000;
  const ore = A>0 ? (Ah*rend)/A : null;

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
        <div>
          <label style={lbl}>Capacità batteria (Ah)</label>
          <input value={capacita} onChange={e=>setCapacita(e.target.value)} style={inp} placeholder="Es. 7"/>
        </div>
        <div>
          <label style={lbl}>Assorbimento totale (mA)</label>
          <input value={assorbimento} onChange={e=>setAssorbimento(e.target.value)} style={inp} placeholder="Es. 350"/>
        </div>
      </div>
      <div style={{ marginBottom:16 }}>
        <label style={lbl}>Rendimento batteria considerato (%)</label>
        <input value={rendimento} onChange={e=>setRendimento(e.target.value)} style={inp}/>
      </div>

      <div style={{ background:"#fef2f2", border:"1px solid #fecaca", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Autonomia stimata</div>
        <div style={{ fontSize:22, fontWeight:800, color:"#dc2626" }}>
          {ore===null ? "—" : ore.toLocaleString("it-IT",{maximumFractionDigits:1})}
          <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>ore</span>
        </div>
        {ore!==null && <div style={{ fontSize:12, color:"#6b7280", marginTop:4 }}>≈ {(ore/24).toLocaleString("it-IT",{maximumFractionDigits:1})} giorni</div>}
      </div>
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        Considera l'assorbimento in stand-by; in caso di allarme attivo l'autonomia reale è inferiore.
      </div>

      <button onClick={()=>{setCapacita("");setAssorbimento("");setRendimento("80");}}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
